<template>
  <div>
    <base-nav
      v-model="showMenu"
      class="navbar-absolute top-navbar"
      type="white"
      containerClasses="container-fluid px-0"
      :transparent="true"
    >
      <div slot="brand" class="navbar-wrapper w-100 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="navbar-toggle d-inline d-lg-none">
            <button v-if="showBackButton" type="button" class="navbar-toggler" @click="goBack">
              <p><i class="tim-icons icon-minimal-left"></i></p>
            </button>
          </div>
          <div class="navbar-brand text-truncate">{{ routeName }}</div>
        </div>
      </div>

      <audio ref="audioNotificacion" src="@/assets/audio/notificacion.mp3" preload="auto"></audio>

      <ul class="navbar-nav" :class="isRTL ? 'mr-auto' : 'ml-auto'">
        <div class="d-none d-lg-block">
          <Tema />
        </div>

        <base-dropdown
          v-if="LasNotificaciones"
          style="max-width: 90vw;"
          tag="li"
          :menu-on-right="!isRTL"
          title-tag="a"
          title-classes="nav-link"
          menu-classes="dropdown-black desktop-notif-dropdown mx-0"
          class="nav-item d-none d-lg-flex"
        >
          <template slot="title">
            <div :class="HayNotificacionClass"></div>
            <i class="fas fa-bell"></i>
          </template>

          <div class="dsk-notif-header">
            <div class="dsk-menu-icon dmi-amber"><i class="fas fa-bell"></i></div>
            <span class="dsk-notif-title">Notificaciones</span>
            <span class="dsk-notif-count" v-if="LasNotificaciones.length">{{ LasNotificaciones.length }}</span>
          </div>

          <div class="dsk-divider"></div>

          <Main-Cargando :cargando="CargaNoti">
            <div class="dsk-notif-list" @wheel.stop @touchmove.stop>
              <div
                v-for="(notificacion, index) in LasNotificaciones"
                :key="'dsk-notif-' + notificacion.id"
                class="dsk-notif-item"
              >
                <Notificacion v-model="LasNotificaciones[index]" @Actualizar="Actualiza" />
              </div>
              <div v-if="!LasNotificaciones.length" class="dsk-notif-empty">
                <i class="fas fa-check-circle"></i>
                <span>No hay notificaciones</span>
              </div>
            </div>
          </Main-Cargando>

          <div class="dsk-notif-footer" v-if="LasNotificaciones.length">
            <a href="#" @click.prevent="BorrarTodas" class="dsk-notif-footer-link">
              <i class="fas fa-check-double"></i> Marcar todas como leídas
            </a>
          </div>
        </base-dropdown>

        <base-dropdown
          tag="li"
          :menu-on-right="!isRTL"
          title-tag="a"
          class="nav-item d-none d-lg-flex"
          title-classes="nav-link"
          menu-classes="dropdown-black desktop-profile-dropdown"
        >
          <template slot="title">
            <div class="photo"><img :src="FotoURL" /></div>
            <b class="caret d-none d-lg-block d-xl-block"></b>
          </template>

          <div class="dsk-user-header">
            <div class="dsk-user-avatar">
              <img :src="FotoURL" />
            </div>
            <div class="dsk-user-info">
              <div class="dsk-user-name">{{ Nombre }}</div>
              <div class="dsk-user-role">{{ $SuscripcionesUsuarios.getEtiqueta() }}</div>
            </div>
          </div>

          <div class="dsk-divider"></div>

          <div class="dsk-section-label">CUENTA</div>
          <router-link to="/usuarios/perfil" class="dsk-menu-item">
            <div class="dsk-menu-icon dmi-green"><i class="fas fa-user"></i></div>
            <span>Mi perfil</span>
            <i class="fas fa-chevron-right dsk-menu-chevron"></i>
          </router-link>
          <router-link to="/usuarios/comentarios" class="dsk-menu-item">
            <div class="dsk-menu-icon dmi-blue"><i class="fas fa-lightbulb"></i></div>
            <span>Comentarios</span>
            <i class="fas fa-chevron-right dsk-menu-chevron"></i>
          </router-link>
          <a :href="soporteURL" target="_blank" class="dsk-menu-item">
            <div class="dsk-menu-icon dmi-teal"><i class="fas fa-headset"></i></div>
            <span>Soporte</span>
            <i class="fas fa-chevron-right dsk-menu-chevron"></i>
          </a>

          <div class="dsk-divider"></div>

          <template v-if="SuscripcionesUsuario && SuscripcionesUsuario.length">
            <div class="dsk-section-label">SUSCRIPCIONES</div>
            <a
              href="#"
              v-for="su in suscripcionesOrdenadas"
              :key="'dsk-sus-' + su.suscripcionID"
              class="dsk-company-item"
              :class="{ 'dsk-company-active': su.suscripcionID == suscripcionActualID }"
              @click.prevent="CambiaSuscripcion(su.suscripcionID)"
            >
              <div class="dsk-company-badge" :class="{ 'dsk-badge-active': su.suscripcionID == suscripcionActualID }">
                <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-check" style="font-size: 11px"></i>
                <template v-else>{{ su.suscripcion.etiqueta.charAt(0).toUpperCase() }}</template>
              </div>
              <div class="dsk-company-info">
                <div class="dsk-company-name">{{ su.suscripcion.etiqueta }}</div>
                <div class="dsk-company-role">{{ ObtenEtiquetaPerfil(su.perfilID) }}</div>
              </div>
              <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-circle dsk-company-active-dot"></i>
            </a>
            <div class="dsk-divider"></div>
          </template>

          <router-link to="/logout" class="dsk-menu-item dsk-logout-item">
            <div class="dsk-menu-icon dmi-red"><i class="fas fa-sign-out-alt"></i></div>
            <span>Cerrar sesión</span>
          </router-link>
        </base-dropdown>
      </ul>
    </base-nav>

    <transition name="mobile-panel-fade">
      <div class="mobile-backdrop" v-show="mobileMenuVisible" @click="closeMobileMenu"></div>
    </transition>

    <transition name="mobile-panel-slide">
      <div class="mobile-panel" v-show="mobileMenuVisible">
        <div class="mobile-panel-header">
          <div class="mobile-panel-user">
            <div class="mobile-panel-avatar">
              <img :src="FotoURL" />
            </div>
            <div class="mobile-panel-user-info">
              <div class="mobile-panel-user-name">{{ Nombre }}</div>
              <div class="mobile-panel-user-role">{{ $SuscripcionesUsuarios.getEtiqueta() }}</div>
            </div>
          </div>
          <button class="mobile-panel-close" @click="closeMobileMenu">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mobile-panel-section" v-if="LasNotificaciones && LasNotificaciones.length">
          <button class="mobile-section-toggle" @click="mobileNotifOpen = !mobileNotifOpen">
            <div class="mobile-section-toggle-left">
              <div class="mobile-menu-icon mi-bell"><i class="fas fa-bell"></i></div>
              <span>Notificaciones</span>
              <span class="mobile-notif-badge">{{ LasNotificaciones.length }}</span>
            </div>
            <i class="fas mobile-section-chevron" :class="mobileNotifOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <div class="mobile-notif-list" v-show="mobileNotifOpen">
            <Main-Cargando :cargando="CargaNoti">
              <div
                v-for="(notificacion, index) in LasNotificaciones"
                :key="'mob-notif-' + notificacion.id"
                class="mobile-notif-item"
              >
                <Notificacion v-model="LasNotificaciones[index]" @Actualizar="Actualiza" @abrir="closeMobileMenu" />
              </div>
            </Main-Cargando>
          </div>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section">
          <div class="mobile-section-label">CUENTA</div>
          <router-link to="/usuarios/perfil" class="mobile-menu-item" @click.native="closeMobileMenu">
            <div class="mobile-menu-icon mi-green"><i class="fas fa-user"></i></div>
            <span>Mi perfil</span>
            <i class="fas fa-chevron-right mobile-menu-chevron"></i>
          </router-link>
          <router-link to="/usuarios/comentarios" class="mobile-menu-item" @click.native="closeMobileMenu">
            <div class="mobile-menu-icon mi-blue"><i class="fas fa-lightbulb"></i></div>
            <span>Comentarios</span>
            <i class="fas fa-chevron-right mobile-menu-chevron"></i>
          </router-link>
          <a :href="soporteURL" target="_blank" class="mobile-menu-item" @click="closeMobileMenu">
            <div class="mobile-menu-icon mi-teal"><i class="fas fa-headset"></i></div>
            <span>Soporte</span>
            <i class="fas fa-chevron-right mobile-menu-chevron"></i>
          </a>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section">
          <div class="mobile-section-label">APARIENCIA</div>
          <div class="mobile-tema-wrap">
            <Tema />
          </div>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section" v-if="SuscripcionesUsuario && SuscripcionesUsuario.length">
          <div class="mobile-section-label">SUSCRIPCIONES</div>
          <a
            href="#"
            v-for="su in suscripcionesOrdenadas"
            :key="'mob-sus-' + su.suscripcionID"
            class="mobile-company-item"
            :class="{ 'mobile-company-active': su.suscripcionID == suscripcionActualID }"
            @click.prevent="CambiaSuscripcion(su.suscripcionID)"
          >
            <div class="mobile-company-badge" :class="{ 'badge-active': su.suscripcionID == suscripcionActualID }">
              <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-check" style="font-size: 12px"></i>
              <template v-else>{{ su.suscripcion.etiqueta.charAt(0).toUpperCase() }}</template>
            </div>
            <div class="mobile-company-info">
              <div class="mobile-company-name">{{ su.suscripcion.etiqueta }}</div>
              <div class="mobile-company-role">{{ ObtenEtiquetaPerfil(su.perfilID) }}</div>
            </div>
            <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-circle mobile-company-active-dot"></i>
          </a>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section mobile-section-logout">
          <router-link to="/logout" class="mobile-menu-item mobile-logout-item" @click.native="closeMobileMenu">
            <div class="mobile-menu-icon mi-red"><i class="fas fa-sign-out-alt"></i></div>
            <span>Cerrar sesión</span>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { BaseNav } from '@/components';
import Notificacion from './Notificacion';
import swal from 'sweetalert2';
import Tema from '@/Vistas/Main/Tema.comp.vue';

import Notificaciones from '@/api-services/notificaciones.service';
import Usuarios from '@/api-services/usuarios.service';
import SuscripcionesUsuarios from '@/api-services/suscripciones.usuarios.service';

export default {
  components: {
    BaseNav,
    Notificacion,
    Tema,
  },
  props: {
    FotoURL: {
      type: String,
      default: '/img/default-avatar.png',
      description: 'Contiene la url de la foto del usuario',
    },
    Nombre: {
      type: String,
      default: 'El Usuario',
      description: 'Contiene el nombre del usuario',
    },
    soporteURL: {
      type: String,
      default: 'https://support.eclock.com.mx/portal/es/kb/eclock',
      description: 'URL de Soporte Técnico',
    },
    SuscripcionesUsuario: Array,
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      isMobileView: false,
      LasNotificaciones: null,
      mobileNotifOpen: false,
      CargaNoti: false,
    };
  },
  computed: {
    mobileMenuVisible() {
      return this.showMenu && this.isMobileView;
    },
    suscripcionActualID() {
      return this.$SuscripcionesUsuarios.getSuscripcionID();
    },
    suscripcionesOrdenadas() {
      if (!this.SuscripcionesUsuario || !this.SuscripcionesUsuario.length) return [];
      const actualID = this.suscripcionActualID;
      const activa = this.SuscripcionesUsuario.filter((su) => su.suscripcionID == actualID);
      const otras = this.SuscripcionesUsuario.filter((su) => su.suscripcionID != actualID);
      return [...activa, ...otras];
    },
    HayNotificacionClass() {
      if (this.LasNotificaciones && this.LasNotificaciones.length > 0) return ' notification';
      return '';
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name || 'Inicio');
    },
    isRTL() {
      return false;
    },
    showBackButton() {
      return this.$route.name !== 'Home';
    },
  },
  watch: {
    $route() {
      this.closeMobileMenu();
    },
    mobileMenuVisible(open) {
      if (open) {
        this._savedScrollY = window.scrollY;
        document.documentElement.classList.add('mobile-menu-open');
      } else {
        document.documentElement.classList.remove('mobile-menu-open');
        window.scrollTo(0, this._savedScrollY || 0);
      }
    },
    LasNotificaciones() {
      this.CargaNoti = true;
      setTimeout(() => {
        this.CargaNoti = false;
      }, 500);
    },
  },
  mounted() {
    this.Actualizar();
    this.isMobileView = window.innerWidth < 992;
    this._handleResize = () => {
      this.isMobileView = window.innerWidth < 992;
    };
    window.addEventListener('resize', this._handleResize);
  },
  beforeDestroy() {
    if (this._handleResize) {
      window.removeEventListener('resize', this._handleResize);
    }
    document.documentElement.classList.remove('mobile-menu-open');
  },
  methods: {
    closeMobileMenu() {
      this.showMenu = false;
    },
    ObtenEtiquetaPerfil(PerfilID) {
      return SuscripcionesUsuarios.ObtenEtiquetaPerfil(PerfilID);
    },
    Actualiza(comp) {
      this.CargaNoti = true;
      Notificaciones.Actualiza(comp, (LasNotificaciones) => {
        this.LasNotificaciones = LasNotificaciones;
        setTimeout(() => {
          this.CargaNoti = false;
          this.LasNotificaciones = LasNotificaciones;
        }, 500);
      });
    },
    Actualizar() {
      Notificaciones.Obten(this, (LasNotificaciones, Sonido) => {
        this.LasNotificaciones = LasNotificaciones;
        if (Sonido && this.$refs.audioNotificacion) {
          this.$refs.audioNotificacion.play();
        }
      });
    },
    BorrarTodas() {
      if (!this.LasNotificaciones || !this.LasNotificaciones.length) return;
      this.CargaNoti = true;
      let pendientes = this.LasNotificaciones.length;
      let completadas = 0;
      this.LasNotificaciones.forEach((notif) => {
        Notificaciones.delete(this, notif.id, () => {
          completadas++;
          if (completadas >= pendientes) {
            this.Actualizar();
          }
        });
      });
    },
    CambiaSuscripcion(SuscripcionID) {
      if (SuscripcionID == this.suscripcionActualID) {
        this.closeMobileMenu();
        return;
      }

      SuscripcionesUsuarios.setSuscripcionID(SuscripcionID);
      Usuarios.getPerfilLocal(() => {}, true);
      this.closeMobileMenu();

      this.$nextTick(() => {
        swal
          .fire({
            title: 'Listo',
            text: 'Se ha cambiado la suscripción seleccionada.',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-fill',
            },
            buttonsStyling: false,
          })
          .then(() => {
            window.location.reload(false);
          });
      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-navbar {
  top: 0px;
}

.navbar-nav {
  display: flex !important;
  align-items: center !important;
  gap: 4px;
}

::v-deep .nav-item {
  display: flex;
  align-items: center;
}

::v-deep .nav-link {
  display: flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  font-size: 1.1rem;
}

::v-deep .nav-item .fas {
  font-size: 1.05rem;
  line-height: 1;
}

::v-deep .photo {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

::v-deep .desktop-profile-dropdown,
::v-deep .desktop-notif-dropdown {
  min-width: 300px;
  padding: 0 !important;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: linear-gradient(180deg, #0d1426 0%, #111a2e 50%, #162038 100%) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;
  overflow: hidden;
}

::v-deep .desktop-notif-dropdown {
  min-width: 380px;
  max-width: 420px;
}

.dsk-user-header,
.dsk-notif-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 18px 14px;
}

.dsk-user-avatar,
.mobile-panel-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  border: 2.5px solid #2ecc71;
  box-shadow: 0 0 12px rgba(46, 204, 113, 0.25);
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.mobile-panel-avatar {
  width: 48px;
  height: 48px;
}

.dsk-user-info {
  min-width: 0;
}

.dsk-user-name,
.dsk-notif-title,
.mobile-panel-user-name {
  font-size: 15px;
  font-weight: 700;
  color: #f0f4ff;
  line-height: 1.2;
}

.mobile-panel-user-name {
  font-size: 17px;
}

.dsk-user-role,
.mobile-panel-user-role {
  font-size: 10px;
  font-weight: 600;
  color: #2ecc71;
  margin-top: 3px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(46, 204, 113, 0.1);
  padding: 2px 8px;
  border-radius: 100px;
  border: 1px solid rgba(46, 204, 113, 0.15);
}

.mobile-panel-user-role {
  font-size: 11px;
}

.dsk-section-label,
.mobile-section-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #5a6b85;
  padding: 10px 18px 4px;
}

.mobile-section-label {
  padding: 12px 20px 6px;
}

.dsk-divider,
.mobile-panel-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 6px 16px;
}

.mobile-panel-divider {
  margin: 6px 20px;
}

.dsk-menu-item,
.mobile-menu-item,
.dsk-company-item,
.mobile-company-item {
  display: flex !important;
  align-items: center !important;
  gap: 12px;
  color: #f0f4ff !important;
  text-decoration: none !important;
  transition: background 0.15s;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    text-decoration: none !important;
  }

  span {
    flex: 1;
  }
}

.dsk-menu-item,
.dsk-company-item {
  padding: 10px 18px !important;
}

.mobile-menu-item,
.mobile-company-item {
  padding: 12px 20px;
}

.dsk-menu-chevron,
.mobile-menu-chevron {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.15);
}

.dsk-menu-icon,
.mobile-menu-icon,
.dsk-company-badge,
.mobile-company-badge {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dsk-menu-icon,
.mobile-menu-icon {
  font-size: 13px;
}

.dsk-company-badge,
.mobile-company-badge {
  background: rgba(46, 204, 113, 0.08);
  border: 1px solid rgba(46, 204, 113, 0.15);
  font-weight: 700;
  color: #2ecc71;
  transition: all 0.2s;
}

.dsk-menu-icon.dmi-green,
.mobile-menu-icon.mi-green {
  background: rgba(46, 204, 113, 0.12);
  color: #2ecc71;
}

.dsk-menu-icon.dmi-blue,
.mobile-menu-icon.mi-blue,
.dsk-menu-icon.dmi-blue {
  background: rgba(59, 158, 255, 0.1);
  color: #3b9eff;
}

.dsk-menu-icon.dmi-teal,
.mobile-menu-icon.mi-teal {
  background: rgba(0, 188, 212, 0.1);
  color: #00bcd4;
}

.dsk-menu-icon.dmi-amber,
.mobile-menu-icon.mi-bell {
  background: rgba(245, 166, 35, 0.1);
  color: #f5a623;
}

.dsk-menu-icon.dmi-red,
.mobile-menu-icon.mi-red {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.dsk-company-active,
.mobile-company-active {
  background: rgba(46, 204, 113, 0.05);
  border-left: 3px solid #2ecc71;
}

.dsk-company-badge.dsk-badge-active,
.mobile-company-badge.badge-active {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  border-color: #2ecc71;
  color: #fff;
  box-shadow: 0 0 12px rgba(46, 204, 113, 0.3);
}

.dsk-company-active-dot,
.mobile-company-active-dot {
  font-size: 6px;
  color: #2ecc71;
  flex-shrink: 0;
  filter: drop-shadow(0 0 4px rgba(46, 204, 113, 0.5));
}

.dsk-company-info,
.mobile-company-info {
  flex: 1;
  min-width: 0;
}

.dsk-company-name,
.mobile-company-name {
  font-size: 13px;
  font-weight: 500;
  color: #f0f4ff;
  line-height: 1.3;
}

.dsk-company-role,
.mobile-company-role {
  font-size: 10px;
  color: #2ecc71;
  margin-top: 2px;
}

.dsk-notif-count,
.mobile-notif-badge {
  font-size: 11px;
  font-weight: 600;
  color: #3b9eff;
  background: rgba(59, 158, 255, 0.15);
  padding: 2px 10px;
  border-radius: 100px;
  border: 1px solid rgba(59, 158, 255, 0.2);
}

.mobile-notif-badge {
  color: #fff;
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  min-width: 22px;
  text-align: center;
}

.dsk-notif-list,
.mobile-notif-list {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.dsk-notif-list {
  max-height: 50vh;
  padding: 4px 8px;
}

.mobile-notif-list {
  max-height: 320px;
  padding: 6px 14px 10px;
}

.dsk-notif-item,
.mobile-notif-item {
  margin-bottom: 6px;
}

::v-deep .desktop-notif-dropdown .dsk-notif-item .card {
  background: rgba(255, 255, 255, 0.04) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 10px !important;

  h4,
  h5,
  p,
  a {
    color: #f0f4ff !important;
  }
}

.dsk-notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 18px;
  color: #5a6b85;
  font-size: 13px;
}

.dsk-notif-footer {
  padding: 12px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: center;
}

.dsk-notif-footer-link {
  color: #3b9eff !important;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none !important;
}

.mobile-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1079;
}

.mobile-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 88vw;
  max-width: 380px;
  background: linear-gradient(180deg, #0d1426 0%, #111a2e 50%, #162038 100%);
  z-index: 1080;
  overflow-y: auto;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.6);
  border-left: 1px solid rgba(255, 255, 255, 0.06);
}

.mobile-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.mobile-panel-close {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #7a8ba8;
}

.mobile-panel-section {
  padding: 2px 0;
}

.mobile-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  color: #f0f4ff;
}

.mobile-section-toggle-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-panel-fade-enter-active,
.mobile-panel-fade-leave-active {
  transition: opacity 0.25s ease;
}

.mobile-panel-fade-enter,
.mobile-panel-fade-leave-to {
  opacity: 0;
}

.mobile-panel-slide-enter-active {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.mobile-panel-slide-leave-active {
  transition: transform 0.2s ease-in;
}

.mobile-panel-slide-enter,
.mobile-panel-slide-leave-to {
  transform: translateX(100%);
}

.dsk-logout-item,
.mobile-logout-item {
  color: #dc3545 !important;

  span {
    color: #dc3545;
  }
}

::v-deep .mobile-tema-wrap {
  .nav-item {
    padding: 0;
  }

  .nav-link {
    padding: 12px 20px;
    color: #f0f4ff;

    p {
      display: inline-block !important;
      margin: 0;
      color: #f0f4ff;
    }
  }
}
</style>

<style lang="scss">
html.mobile-menu-open,
html.mobile-menu-open body {
  overflow: hidden !important;
  height: 100% !important;
  position: relative !important;
}

body.white-content {
  .dropdown-menu.dropdown-black,
  .desktop-profile-dropdown,
  .desktop-notif-dropdown,
  .mobile-panel {
    background: #ffffff !important;
    border-color: rgba(0, 0, 0, 0.1) !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
  }

  .dsk-user-name,
  .dsk-notif-title,
  .mobile-panel-user-name,
  .dsk-company-name,
  .mobile-company-name,
  .dsk-menu-item,
  .mobile-menu-item,
  .dsk-company-item,
  .mobile-company-item,
  .mobile-section-toggle {
    color: #1e293b !important;
  }

  .dsk-divider,
  .mobile-panel-divider {
    background: rgba(0, 0, 0, 0.06) !important;
  }

  .mobile-panel-header,
  .dsk-notif-footer {
    border-color: rgba(0, 0, 0, 0.06) !important;
  }

  .mobile-panel-close {
    border-color: rgba(0, 0, 0, 0.1) !important;
    background: rgba(0, 0, 0, 0.03) !important;
    color: #64748b !important;
  }

  .mobile-tema-wrap {
    .nav-link,
    .nav-link p {
      color: #1e293b !important;
    }
  }
}
</style>
